import React, {useState} from 'react';
import { useServices } from '../../../Data/Services';
import Checkboxes from './Checkboxes';
import AddService from '../../../Pages/PricingAndServices/Services/AddService';
import Icon from '../../Icons/Icon';

const Services = (props) => {
    const {services, addService, isLoading} = useServices();

    const options = services ? services.map(s => ({value: s.type, label: s.title, group: s.category})): [{label: 'Loading...', value: ''}];
    const disabled = !services ? true : props.disabled;

    return <>
        <Checkboxes {...{options, disabled, ...props}}
            footer={<AddOther {...{services, addService}} />}
            noItems={isLoading ? 'Loading...' : 'No services, add one below'}
        />
    </>
}

const AddOther = ({services, addService}) => {
    const [adding, setAdding] = useState(false);

    return <>
        <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); setAdding(true); }}
            className="w-full flex flex-row items-center mt-2 pt-1 border-t text-brand fill-brand"
        >
            <Icon icon="Plus" className="w-4 h-4 mr-3 inline-block" />
            <span className="text-sm">Add more services</span>
        </button>

        <AddService isOpen={adding} setIsOpen={setAdding} services={services} addService={addService} showEditInfo />
    </>
}

export default Services;
